
  <div class="graph-container">
    <canvas class="chart-canvas" #chartCanvas></canvas>

    <ng-template [ngIf]="isLoading">
      <div class="graph-spinner-container">
        <ion-spinner color="dark"></ion-spinner>
      </div>
    </ng-template>
    <ion-icon *ngIf="scaleType == 'thumbs'" name="thumbs-up-outline" class="scale scale-0 thumbs-up-4"></ion-icon>
    <ion-icon *ngIf="scaleType == 'thumbs'" name="thumbs-up-outline" class="scale scale-1 thumbs-up-3"></ion-icon>
    <ion-icon *ngIf="scaleType == 'thumbs'" name="thumbs-up-outline" class="scale scale-2 thumbs-up-2"></ion-icon>
    <ion-icon *ngIf="scaleType == 'thumbs'" name="thumbs-up-outline" class="scale scale-3 thumbs-up-1"></ion-icon>
    <ion-icon *ngIf="scaleType == 'thumbs'" name="thumbs-up-outline" class="scale scale-4 thumbs-up-0"></ion-icon>
    <div *ngIf="scaleType == 'mood'" class="scale scale-0 mood"><div class="mood-inner mood-4"></div></div>
    <div *ngIf="scaleType == 'mood'" class="scale scale-1 mood"><div class="mood-inner mood-3"></div></div>
    <div *ngIf="scaleType == 'mood'" class="scale scale-2 mood"><div class="mood-inner mood-2"></div></div>
    <div *ngIf="scaleType == 'mood'" class="scale scale-3 mood"><div class="mood-inner mood-1"></div></div>
    <div *ngIf="scaleType == 'mood'" class="scale scale-4 mood"><div class="mood-inner mood-0"></div></div>
  </div>

